import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import MuiTable from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow, { tableRowClasses } from '@mui/material/TableRow';
// Desktop Table Styled Components
export const StyledTable = styled(MuiTable)(() => ({
  borderCollapse: 'separate',
  borderSpacing: 0,
  width: '100%',
}));
export const StyledTableContainer = styled(TableContainer, {
  shouldForwardProp: (prop) => prop !== 'hasHeaderContent',
})<{
  hasHeaderContent?: boolean;
}>(({ hasHeaderContent }) => ({
  borderRadius: hasHeaderContent ? '0 0 12px 12px' : '12px',
  overflow: 'auto',
}));
export const StyledHeaderTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#F9FAFB',
    fontSize: '12px',
    color: '#475467',
    fontWeight: '500',
    padding: '12px 8px 12px 24px',
    borderBottom: '1px solid #EAECF0',
    '&:first-of-type': {
      paddingLeft: '1.5rem',
    },
    '&:last-of-type': {
      paddingRight: '1.5rem',
    },
  },
}));
export const StyledTableRow = styled(TableRow)(() => ({
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  [`&.${tableRowClasses.root}:hover`]: {
    backgroundColor: '#F9FAFB',
  },
  [`&.${tableRowClasses.selected}`]: {
    backgroundColor: '#F0F9FF',
    '&:hover': {
      backgroundColor: '#E0F2FE',
    },
  },
}));
export const StyledTableBodyCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    padding: '1rem 0 1rem 1.5rem',
    fontSize: '14px',
    color: '#475467',
    borderBottom: '1px solid #F2F4F7',
    '&:first-of-type': {
      paddingLeft: '1.5rem',
      color: theme.palette.text.primary,
      fontSize: '16px',
    },
    '&:last-of-type': {
      paddingRight: '1.5rem',
    },
  },
}));
export const StyledTableFooterCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.footer}`]: {
    padding: '16px 24px',
    borderTop: '1px solid #EAECF0',
    borderBottom: 'none',
  },
}));
// Mobile Card Styled Components
export const MobileCardContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '16px',
}));
export const MobileCard = styled(Box)(() => ({
  backgroundColor: 'white',
  borderRadius: '12px',
  border: '1px solid #EAECF0',
  padding: '16px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  '&:hover': {
    backgroundColor: '#F9FAFB',
  },
  '&.selected': {
    backgroundColor: '#F0F9FF',
    borderColor: '#0EA5E9',
  },
}));
export const MobileCardRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '8px 0',
  borderBottom: '1px solid #F2F4F7',
  '&:last-child': {
    borderBottom: 'none',
  },
}));
export const MobileCardLabel = styled(Box)(() => ({
  fontSize: '12px',
  color: '#475467',
  fontWeight: '500',
  marginBottom: '4px',
}));
export const MobileCardValue = styled(Box)(() => ({
  fontSize: '14px',
  color: '#475467',
  display: 'flex',
  alignItems: 'center',
}));
